var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
export var StaticField = function (_a) {
    var title = _a.title, content = _a.content, contentComponent = _a.contentComponent, dataTestIdTitle = _a.dataTestIdTitle, dataTestIdContent = _a.dataTestIdContent, isOneLiner = _a.isOneLiner, additionalContentProps = __rest(_a, ["title", "content", "contentComponent", "dataTestIdTitle", "dataTestIdContent", "isOneLiner"]);
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 lg:sui-grid-cols-5 sm:sui-mb-2" },
        React.createElement("div", { className: 'sui-col-span-2 sui-pr-5' +
                (isOneLiner ? ' sui-whitespace-nowrap' : '') },
            React.createElement(Typography, { weight: "bold", variant: "body-base", "data-testid": dataTestIdTitle }, title)),
        React.createElement("div", { className: "sui-col-span-3" },
            React.createElement(Typography, __assign({}, additionalContentProps, { component: contentComponent, weight: "regular", variant: "body-base", "data-testid": dataTestIdContent }), content))));
};
